import React from 'react';
import { Pagination, PaginationItem, useMediaQuery, useTheme } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";

const BRAND_PINK = '#C2185B';
const BRAND_PINK_DARK = '#A01651';
const BRAND_PINK_SOFT = '#FCE4EC';
const BRAND_PINK_BORDER = '#F5C8DA';

const StyledPagination = styled(Pagination)`
  & ul {
    flex-wrap: nowrap !important;
    overflow-x: auto;
    gap: 6px;
  }

  & .MuiPaginationItem-root {
    background: #fff;
    border: 1px solid ${BRAND_PINK_BORDER};
    color: ${BRAND_PINK};
    font-weight: 600;
    font-size: 13px;
    min-width: 34px;
    height: 34px;
    border-radius: 8px;
    transition: all 0.15s ease;
  }

  & .MuiPaginationItem-root:hover {
    background: ${BRAND_PINK_SOFT};
    border-color: ${BRAND_PINK};
    color: ${BRAND_PINK_DARK};
  }

  & .MuiPaginationItem-root.Mui-selected {
    background: ${BRAND_PINK};
    border-color: ${BRAND_PINK};
    color: #fff;
    box-shadow: 0 4px 10px -3px rgba(194, 24, 91, 0.45);
  }

  & .MuiPaginationItem-root.Mui-selected:hover {
    background: ${BRAND_PINK_DARK};
    border-color: ${BRAND_PINK_DARK};
    color: #fff;
  }

  & .MuiPaginationItem-root.Mui-disabled {
    background: #F8FAFC;
    border-color: #E2E8F0;
    color: #CBD5E1;
    opacity: 1;
  }

  & .MuiPaginationItem-ellipsis {
    border: none;
    background: transparent;
    color: ${BRAND_PINK};
  }

  & .MuiPaginationItem-previousNext .MuiSvgIcon-root {
    font-size: 18px;
  }
`;

const BackendPagination = ({ count, handleOnChange, currentPage, executeScroll }) => {
    const handleChange = (event, newPage) => {
        handleOnChange(newPage);
        if (executeScroll && typeof executeScroll === 'function') {
            executeScroll();
        }
    };

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    return (
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <StyledPagination
                count={count}
                page={currentPage}
                onChange={handleChange}
                variant="outlined"
                shape="rounded"
                siblingCount={0}
                boundaryCount={isMobile ? 1 : 2}
                sx={{ display: "flex", flexWrap: "nowrap !important" }}
                renderItem={(item) => (
                    <PaginationItem
                        slots={{ previous: ArrowBackIcon, next: ArrowForwardIcon }}
                        {...item}
                    />
                )}
            />
        </Box>
    );
};

export default BackendPagination;
